import {IndigroupModel} from './indigroup.model';

export class ChapterModel
{
	id: number = undefined;
	name: string = undefined;
	soustitre: string = '';
	description: string = '';
	questionnary: number = undefined;
	ordre: number = undefined;

	indiGroups:Array<IndigroupModel> = [];


	constructor(values: Object) {
	   this.exchange(values);
	}
	exchange(values: Object = {}) {
	    for (let p in values) {
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else if(p=='indiGroups') {
		    		values[p].forEach((ig)=>{
		    			this.indiGroups[ig.ordre] = new IndigroupModel(ig);
		    		});
		    	}
		    	else {
		    		this[p] = values[p];
		    	} 
		    }
		  }
	}

}